// extracted by mini-css-extract-plugin
export default {"whiteConteiner":"warning_whiteConteiner__V9ICv","warning":"warning_warning__n1OHN","warningIcon":"warning_warningIcon__OoVPv","warningTxt":"warning_warningTxt__ls3CN"};